export default __webpack_public_path__ + "static/media/hmsa-logo.ac2086cf.png";